/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Practice_Session_EndingInputs */



/**
* | output |
* | --- |
* | "Writing your feedback…" |
*
* @param {Practice_Session_EndingInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const practice_session_ending = /** @type {((inputs?: Practice_Session_EndingInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Practice_Session_EndingInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Je feedback wordt gemaakt…")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Votre feedback est en préparation…")
	return /** @type {LocalizedString} */ ("Writing your feedback…")
});